import { Text } from '@iwoca/orion';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './trueLayer.module.css';

export const OpenBankingInfo = () => {
    return (
        <div
            className="space-y-m"
            data-testid="open-banking-info-exclude-branch"
        >
            <Text className="font-bold text-structure-40">
                <FormattedMessage
                    id="_.true_layer.link_bank_account"
                    defaultMessage="Link my bank account"
                />
            </Text>
            <ul className="list-inside list-disc">
                <li className="font-reg text-structure-40">
                    <FormattedMessage
                        id="_.true_layer.info"
                        defaultMessage="Open Banking is a secure way to share your business banking data without sharing your password. When you link your account with Open Banking, it means we can assess your application more quickly, now and in the future. {link}"
                        values={{
                            link: <LearnMoreLink />
                        }}
                    />
                </li>
                <li className="font-reg text-structure-40">
                    <FormattedMessage
                        id="_.true_layer.more_info"
                        defaultMessage="Your transactions must cover the stated period and be from the account(s) where the majority of your business revenue is generated."
                    />
                </li>
            </ul>
        </div>
    );
};

const LearnMoreLink = () => {
    const intl = useIntl();

    return (
        <a
            className={styles.link}
            href={intl.formatMessage({
                id: '_.true_layer.info_link',
                defaultMessage:
                    'https://www.openbanking.org.uk/what-is-open-banking/'
            })}
            target="_blank"
            rel="noopener noreferrer"
        >
            <FormattedMessage
                id="_.true_layer.info_link_text"
                defaultMessage="Learn More"
            />
        </a>
    );
};
